export default __webpack_public_path__ + "static/media/javascript.ff879357.svg";